<template>
  <div class="container">
    <div class="bg"></div>
    <div class="top">
      <div class="logo"><router-link to='/Index'><img src="../assets/logo.png"></router-link></div>
    </div>
    <ul class="nav">
      <li ><router-link to='/Index'>企业介绍</router-link></li>
      <li style="position: relative" v-on:click="showmenu">产品列表
        <ul class="ej" v-if="menu_show">
          <li class="current"><router-link to='/Product'>产品列表</router-link></li>
          <li><router-link to='/Add'>添加产品</router-link></li>
          <li><router-link to='/Model_list'>添加溯源</router-link></li>
        </ul>
      </li>
      <li class="current" style="position: relative" v-on:click="showmenu1">直播
        <ul class="ej" v-if="menu_show1">
          <li class="current"><router-link to='/Video'>直播</router-link></li>
          <li><router-link to='/Weather'>气象数据</router-link></li>
        </ul>
      </li>
    </ul>
    <div class="vd">
      <img src="../assets/banner.jpg">
      <p class="sxt"><span>当前1个摄像头在线</span><span>共安装2个摄像头</span></p>
    </div>
    <div class="vd" style="margin-top: 70px">
      <div class="bt">购买网络摄像头</div>
      <div class="bt">联系安装师傅</div>
    </div>
    <div class="tab">
      <cube-tab-bar
        v-model="selectedLabelDefault"
        :data="tabs"
        @change="changeHandler">
      </cube-tab-bar>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Video",
    data(){
      return {
        menu_show:false,
        menu_show1:false,
        selectedLabelDefault: '首页',
        tabs: [{
          label: '首页',
          icon: 'cubeic-home'
        },
          {
            label: '我的',
            icon: 'cubeic-person'
          }],
        items: [
          {
            url: 'http://www.didichuxing.com/',
            image: 'http://www.zixunxueli.com/img/banner.jpg'
          }
        ]
      }
    },
    methods:{
      showmenu1(){
        if(this.menu_show1==true){
          this.menu_show1=false
        }
        else if(this.menu_show1==false){
          this.menu_show1=true
        }
      },
      changeHandler (label) {
        if(label=='我的'){
          this.$router.push({path:'Center'});
        }
        else{
          this.$router.push({path:'Index'});
        }
      },
      showmenu(){
        if(this.menu_show==true){
          this.menu_show=false
        }
        else if(this.menu_show==false){
          this.menu_show=true
        }
      }


    }
  };
</script>

<style scoped>
  *{
    padding: 0;
    margin: 0;
  }
  .bg{
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    background-color: #f5f5f5;
  }
  .top{
    height:3rem;
    background-color: #45b035;
  }
  .logo{
    width: 30%;
    line-height: 3rem;
  }
  .logo img{
    width: 100%;
    margin-top: 10px;

  }
  .tab{
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid #f1ebeb;
    background-color: white;
  }
  .nav{
    list-style: none;
    display: flex;
    justify-content: space-between;
    border-bottom:  1px solid #f1ebeb;
    background-color: white;
  }
  .nav a{
    color: #333333;
  }
  .nav li{
    width: 33%;
    padding: 10px 0;
  }
  .nav li:hover{
    color: #45b035;
  }
  .current{
    color: #45b035;
  }
  .banner img{
    width: 100%;
  }
  .introduce{
    text-align: left;
    font-size: 0.8rem;
    color: #999999;
    padding:0rem 1rem;
    background-color: white;
    margin: 0 0.5rem;
    padding:0.8rem;
    border-radius: 6px;
    z-index: 1;
    position: relative;
    top: -20px;
  }
  .introduce p{
    margin-bottom: 0.5rem;
  }
  .store {
    background-color: white;
    padding: 0.8rem;
  }
  h3{
    font-size:0.9rem;
    text-align: left;
    position: relative;
    padding-left: 10px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 10px;
  }
  h3:before{
    position: absolute;
    content: "";
    left: 0;
    top: 0;
    width: 3px;
    height: 16px;
    background-color: #45b035;
  }
  .img_content{
    display: flex;
    margin: 10px 0;
    justify-content: space-around;
  }
  .store p{
    width: 30%;
  }
  .store p img{
    width: 100%;
  }
  .list{
    padding-bottom:60px;
    margin-top: 10px;
  }
  .left_img{
    width: 30%;
  }
  .left_img img{
    width: 100%;
  }
  .list_content{
    display: flex;
    padding: 5px;
    margin-top: 10px;
    box-shadow: 0px 0px 3px #ece6e6;
  }
  .title{
    width: 70%;
    text-align: left;
  }
  h4{
    font-size:1rem;
    margin-top: 1.3rem;
    color: #2c3e50;
    margin-left: 1rem;
  }
  .sub{
    font-size: 0.8rem;
    margin-top: 1.3rem;
    color:red;
    margin-left: 1rem;
  }
  .more{
    float: right;
    color: #b8b8b8;
    font-size: 0.8rem;
  }
  .look{
    float: right;
    color: #45b035;
  }
  .it{
    font-size: 0.6rem;
    margin: 5px 0;
    margin-left: 1rem;
  }
  .ej{
    position: absolute;
    width: 100%;
    background-color: #45b035;
    left: 0;
    top: 38px;
    z-index: 100;
    text-align: right;
  }
  .ej li{
    width: 100%;
    text-align: center;
    color: white;
    border-bottom: 1px solid #fff;
  }

  .ej li a{
    width: 100%;
    text-align: center;
    color: white;

  }
  .ej li a:hover{
    color: white;
  }
  .vd img{
    width: 100%;
  }
  .sxt{
    width: 90%;
    margin: 10px auto;
    color: #999999;
    font-size: 0.8rem;
  }
  .sxt span:nth-child(1){
    float:left;
  }
  .sxt span:nth-child(2){
    float: right;
  }
  .vd .bt{
    width: 90%;
    padding: 15px;
    margin: 20px auto;
    text-align: center;
    color: white;
    background-color:#fc9153;
  }
</style>



// WEBPACK FOOTER //
// src/components/Weather.vue